import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"
import Card from "../../UI/Card"
import classes from './LessonContent.module.css'
import { useDispatch, useSelector } from "react-redux";
import SlLessonContent from "./SlLessonContent";
import { lessonsApi } from '../../../utils'
import { LessonContentTypeEnumText } from '../../../models/LessonContentTypeEnum'
import CMS from "../../cms/Editor/CMS";
import Loader from "../../UI/Loader";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import { onKeyDown } from "../../../service";
import { AttachmentTypeEnumText } from "../../lms-shared/models/AttachmentTypeEnum";
import MultiAssessments from "./MultiAssessments";
import ScrollLTR from "../../lms-shared/UI/ScrollLTR";

const LessonContent = forwardRef(({ id, materialContentPath, materialContentType, setLesson, setTempSave, setTempCMSStatus, studyGroupId, data, assessments, setAssessments }, ref) => {

    const texts = useSelector(state => state.translate.texts);
    const [load, setLoad] = useState(false);
    const dispatch = useDispatch()

    useEffect(() => {
        setLoad(false)
    }, [])

    const changeType = (type) => {
        setLesson({ materialContentType: type })
        // move set valid to useefect on <materialContentPath>
    }

    const lessonContentTypesEnum = {
        Storyline: SlLessonContent,
        SLC: CMS
    }

    const contentRef = useRef();

    const saveFile = (myFile, ref) => new Promise((resolve, reject) => {
        setLoad(true)
        setTempSave("שומר.....")
        const formData = {
            lessonContent: LessonContentTypeEnumText.Material,
            attachmentType: AttachmentTypeEnumText.File,
            contentType: materialContentType,
            id: id,
            file: myFile
        }

        lessonsApi.lessonsAddFilePost(formData,(error, resdata, response)  => {
            if (error) {
                dispatch(throwApiError({ userMessage: response?.statusCode === 409 ? texts?.lessonExistError : texts?.lessonsAddFileError, error: error, statusCode: response?.statusCode, message: "lessonsAddFilePost " + error.message, level: 2, component: "LessonContent", line: 49 }))
                setTempSave("נכשל בשמירה")
                resolve(false)

            } else {
                setLesson({ materialContentPath: resdata.materialContentPath })
                if (ref && ref.current) {
                    ref.current.src = ref.current.src
                }
                setTempSave("נשמר בהצלחה")
                setTempCMSStatus("שמור")
                resolve(true)
            }
            setLoad(false)
        })
    })


    useImperativeHandle(ref, () => ({
        async stepNext() {
            if (materialContentType === "SLC") {
                if (contentRef.current && contentRef.current.save) {
                    await contentRef.current.save()
                    console.log("save end")
                }
            }
        }
    }))

    return (
        <div className={classes.LessonContent}>
            <ScrollLTR dropStyle={{ height: "100%" }}>
                {(!materialContentType || materialContentType === "PDF") && <div className={classes.TypeCreateLesson}>
                    <h2>{texts.chooseTypeNewLessonContent}</h2>
                    <div className={classes.TypesContainer}>
                        <div className={classes.CardWarrper} onClick={() => changeType("SLC")} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeType("SLC"))}>
                            <Card> <div className={classes.CmsTexts}>Skillz  CMS </div></Card>
                        </div>
                        <div className={classes.CardWarrper} onClick={() => changeType("Storyline")} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeType("Storyline"))}>
                            <Card> <div className={classes.StoryLine} ></div> </Card>
                        </div>
                    </div>
                </div>}
                {
                    materialContentType && materialContentType !== "PDF" && (() => {
                        const Compnent = lessonContentTypesEnum[materialContentType];
                        return <Compnent ref={contentRef} lessonId={id} setTempCMSStatus={setTempCMSStatus} saveFile={saveFile} materialContentPath={materialContentPath && `${materialContentPath}/`} studyGroupId={studyGroupId}>
                        </Compnent>
                    })()
                }
                {load && <Loader />}
                {/* {load && <div className={classes.BackDrop}><div className={classes.Loader}></div></div>} */}
                {materialContentType ? <MultiAssessments data={data} assessments={assessments} setAssessments={setAssessments} /> : ''}
            </ScrollLTR>
        </div>
    )
})
export default LessonContent